<script lang="ts" setup>
import { ref } from "vue"
import { ButtonSize, TuIconButton, TuPopover, usePopover } from "@tinyurldev/tu-ui-vue"

import useTranslation from "@Composables/useTranslation"

//
// Setup
const { __ } = useTranslation()

//
// Emit
const emit = defineEmits<{
  (e: "edit"): void
  (e: "delete"): void
}>()

//
// Data
const isPopoverVisible = ref(false)
const { referenceRef, popoverRef } = usePopover(isPopoverVisible, { placement: "bottom-end" })

//
// Methods
function onToggle(): void {
  isPopoverVisible.value = !isPopoverVisible.value
}

function onEditClick(): void {
  isPopoverVisible.value = false
  emit("edit")
}

function onDeleteClick(): void {
  isPopoverVisible.value = false
  emit("delete")
}
</script>

<template>
  <div class="org-api-action-dropdown">
    <TuIconButton
      ref="referenceRef"
      class="_actions"
      :aria-label="__('organization_api_settings.manage_tokens.token_actions')"
      icon-class="fa-solid fa-gear"
      is-outlined
      :size="ButtonSize.MEDIUM"
      @click="onToggle"
    />

    <TuPopover
      v-show="isPopoverVisible"
      ref="popoverRef"
    >
      <div class="org-api-action-dropdown__menu _actions_menu">
        <button
          class="org-api-action-dropdown__menu-item _edit"
          type="button"
          @click="onEditClick"
        >
          <i class="fa fa-fw fa-pencil" />
          {{ __('organization_api_settings.manage_tokens.edit') }}
        </button>
        <button
          class="org-api-action-dropdown__menu-item org-api-action-dropdown__menu-item--delete _delete"
          type="button"
          @click="onDeleteClick"
        >
          <i class="fa fa-fw fa-trash" />
          {{ __('organization_api_settings.manage_tokens.delete') }}
        </button>
      </div>
    </TuPopover>
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/colors.scss" as color;
@use "@tinyurldev/tu-ui-vue/scss/settings/border.scss" as border;
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;
@use "@tinyurldev/tu-ui-vue/scss/settings/typography.scss" as typography;

.org-api-action-dropdown {
  &__menu {
    display: flex;
    flex-direction: column;
    min-width: 120px;
    padding: spacing.$xs-5 0;

    background-color: color.$background-secondary;
    border-radius: border.$medium-radius;
  }

  &__menu-item {
    display: flex;
    align-items: center;
    gap: spacing.$xxxxs;
    width: 100%;
    padding: spacing.$xxxxs spacing.$xxxs;

    font-size: typography.$xs-font-size;
    font-weight: typography.$font-weight-medium;
    line-height: typography.$xs-line-height;
    text-align: left;
    color: color.$text;

    background: none;
    border: none;
    cursor: pointer;

    &:hover {
      background-color: color.$background-primary;
    }

    &--delete {
      color: color.$alert;
    }
  }
}
</style>
